'use client';

import { useApiClient } from '../../../../contexts/ApiContext';
import { SetRushMidSkinRequestSideEnum } from '../../../../services/generated/Api';
import type { Side } from '../useRushMidMatch';

/** Persist an explicit skin pick to the DB per side. The match reads the skin from the DB,
 *  so nothing is transported on enter. Shared by the solo lobby and the party screens. */
export function useSkinPersist(): (skinSide: Side, picked: string) => void {
  const apiClient = useApiClient();
  return (skinSide, picked) => {
    const side = skinSide === 'ct' ? SetRushMidSkinRequestSideEnum.Ct : SetRushMidSkinRequestSideEnum.T;
    apiClient.api.rushMidControllerSetSkin({ side, skin: picked }).catch(() => {});
  };
}
